// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".seoBox{background-color:#fff;padding:3rem 3.5rem 3.4rem}@media(max-width:768px){.seoBox{padding:3rem 2rem 3.4rem}}.seoBox h2{color:#171933;font-size:3.6rem;line-height:4.3rem;margin-bottom:3rem}@media(max-width:768px){.seoBox h2{font-size:3rem;line-height:3.6rem;text-align:center}}.seoBox p{color:#575766;font-size:1.6rem;line-height:2rem;margin-bottom:3.4rem}.seoBox p:last-child{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
